import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import { ptBR } from "date-fns/locale";
import { parse, format, isValid } from "date-fns";

const DatePickerPT = ({
  value,
  onChange,
  placeholder,
  maxDate,
  minDate,
  ...props
}) => {
  const parseValue = (dateString) => {
    if (!dateString) return null;

    try {
      const date = parse(dateString, "yyyy-MM-dd", new Date());
      return isValid(date) ? date : null;
    } catch {
      return null;
    }
  };

  const handleChange = (date) => {
    if (!date || !isValid(date)) {
      onChange("");
      return;
    }

    const formatted = format(date, "yyyy-MM-dd");
    onChange(formatted);
  };

  const getMaxDate = () => {
    if (!maxDate) return null;
    if (typeof maxDate === "string") {
      return parse(maxDate, "yyyy-MM-dd", new Date());
    }
    return maxDate;
  };

  const getMinDate = () => {
    if (!minDate) return null;
    if (typeof minDate === "string") {
      return parse(minDate, "yyyy-MM-dd", new Date());
    }
    return minDate;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <DatePicker
        value={parseValue(value)}
        onChange={handleChange}
        inputFormat="dd/MM/yyyy"
        maxDate={getMaxDate()}
        minDate={getMinDate()}
        renderInput={(params) => (
          <TextField {...params} fullWidth size="small" label={placeholder} />
        )}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default DatePickerPT;
